import { Component, OnInit, ViewChild, ElementRef, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { UserService } from '../../pages/auth/UserDetails/user.service';
import { GlobalStorage } from '../../../core/Gloabl/Global';
import { Notification } from '../../../core/Notifications/Notification';
import { ProfileService } from 'src/app/modules/profile-module/profile.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  username: string;
  userdata: any;
  useremail: string;
  image_Url;
  test: any = 'Welcome Test';
  message: any;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private user: UserService,
    private store: GlobalStorage,
    private Notifi: Notification,
    private service: ProfileService
  ) { }

  ngOnInit(): void {
    this.service.currentUserImage.subscribe(data => {
      console.log('Test image')
      console.log(data)
      if (data != undefined) {
        this.image_Url = data;
      }
    })
    this.get_profile();   
  }

  receivename($event: string) {
    this.test = $event;   
  }


  toggleSidebar(e) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }

  /**
   * Logout
   */
  onLogout(e) {
    e.preventDefault();
    this.user.logout();
    this.router.navigate(['/auth/login']);
  }

  get_profile() {
    this.service.Get_Userprofile()
      .subscribe((data) => {
        this.userdata = data;
        console.log('Profile Data', this.userdata);
        this.image_Url = this.userdata.imagename;
      })
  }

}